import Service from "./Service";
const baseurl = '/api/partograma';

export default {
    index(params = {}) {
        return Service.get(`${baseurl}`, { params });
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showByIdUsuario(id) {
        return Service.get(`${baseurl}/show-by-idUsuario/${id}`);
    },
    showByLast(id) {
        return Service.get(`${baseurl}/show-by-last/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    storeControl(idPartograma, control) {
        return Service.post(`${baseurl}/${idPartograma}/controles`, control);
    },
    updateControl(idControl, control) {
        return Service.put(`${baseurl}/controles/${idControl}`, control);
    },
    close(idPartograma, datos = {}) {
        return Service.post(`${baseurl}/${idPartograma}/cerrar`, datos);
    },
    print(id) {
        return `${process.env.VUE_APP_BASE_PATH}${baseurl}/print/${id}`;
    }
}
